<template>
  <div style="text-align: center;">
    <p>את/ה בדרך למחוק את <b>{{payload.item_name}}</b></p>
    <p><b>בטוח למחוק?</b></p>
    <div class="flex flex_align_center flex_justify_center" style="margin-top: 30px; border-top: 1px solid rgba(0, 0, 0, 0.1); padding-top: 30px;">
      <a @click="deleteAndRefresh()" class="button is-danger">כן ורענן לי את הדף</a>
      <div style="width: 10px"></div>
      <a @click="deleteWithoutRefresh()" class="button is-danger">כן ואל תרענן</a>
      <div style="width: 10px"></div>
      <a @click="close()" class="button is-info">לא, בטל</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'delete-prompt',
  props: ['payload'],
  methods: {
    deleteAndRefresh () {
      let query = { ...this.$route.query }
      query.refresh_toggle = query.refresh_toggle == 'false'
      this.makeRequest().then(() => {
        this.$router.push({ name: this.$route.name, query: query })
      })
    },
    deleteWithoutRefresh () {
      this.makeRequest().then(() => {
        if (this.payload.refresh) {
          this.payload.refresh()
        }
        this.close()
      })
    },
    close () {
      this.removeModal(this.payload)
    },
    makeRequest () {
      return this.$network_utils[this.payload.method](this.payload.method_params)
    },
    ...mapMutations('modals', ['removeModal'])
  }
}
</script>
